import { makeVar, useReactiveVar } from '@apollo/client';

const hasNewAppVersionVar = makeVar(false);

export const hasNewAppVersion = () => hasNewAppVersionVar();
export const setHasNewAppVersion = (v: boolean) => hasNewAppVersionVar(v);

export const useHasNewAppVersion = () => useReactiveVar(hasNewAppVersionVar);
